document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const submitButton = form.querySelector('input[type="submit"]');
      submitButton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          throw new Error(data.description);
        }
        
        // After successful add, fetch the updated cart
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        // Dispatch our custom event with the cart data
        document.dispatchEvent(new CustomEvent('cart:change', { 
          detail: cart 
        }));
        
        if (window.updateCart) {
          window.updateCart();
        }
        if (window.openCartDrawer) {
          window.openCartDrawer();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Resolve the title from product data first. Fall back to the title element's
        // own text node (NOT its full textContent, which can include a nested <style>
        // block) so the popup never leaks CSS into the message.
        const titleEl = document.querySelector('.product-title');
        const productTitle =
          (window.product && window.product.title) ||
          (titleEl && (titleEl.lastChild || titleEl).textContent.trim()) ||
          'This item';
        // This theme renders variant options as radio inputs (.variant-input), not
        // <select.variant-select>. Read the selected options from the submitted form.
        const variantOptions = Array.from(form.querySelectorAll('.variant-input:checked'))
          .map(input => input.value)
          .join(' / ');
        const itemLabel = variantOptions ? `${productTitle} – ${variantOptions}` : productTitle;
        // Prefer Shopify's actual reason (it comes through as error.message via the
        // `throw new Error(data.description)` above). The generic "no longer available"
        // line is misleading when the item is in stock but e.g. already at its max
        // quantity in the customer's cart. Fall back to it only for opaque errors.
        const apiMessage = (error && typeof error.message === 'string') ? error.message.trim() : '';
        const isUsefulMessage = apiMessage &&
          apiMessage !== 'null' && apiMessage !== 'undefined' &&
          !/^Failed to fetch/i.test(apiMessage);
        const reason = isUsefulMessage ? apiMessage : `Sorry, ${itemLabel} is no longer available.`;

        // Create and show popup message
        const popup = document.createElement('div');
        popup.className = 'cart-popup-message';
        popup.innerHTML = `
          <div class="cart-popup-content">
            <p>${reason}</p>
            <button onclick="this.parentElement.parentElement.remove()">OK</button>
          </div>
        `;
        document.body.appendChild(popup);
        
        // Add styles for the popup
        const style = document.createElement('style');
        style.textContent = `
          .cart-popup-message {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          .cart-popup-content {
            background: white;
            padding: 20px;
            border-radius: 4px;
            text-align: center;
            max-width: 90%;
            width: 400px;
          }
          .cart-popup-content button {
            margin-top: 15px;
            padding: 8px 20px;
            background: #000;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .cart-popup-content button:hover {
            opacity: 0.9;
          }
        `;
        document.head.appendChild(style);
      })
      .finally(() => {
        submitButton.disabled = false;
      });
    });
  });

  // NOTE: Variant selection (the .variant-input radios) is handled inline in
  // sections/product-section-3.liquid, which keeps the hidden variant id, price,
  // button state, and per-size availability in sync. A second handler here used
  // to target a <select.variant-select> that this theme never renders, so it
  // never ran — it has been removed to avoid confusion.
});

// Helper function to format money
function formatMoney(cents) {
  // Get the store's money format from Shopify settings
  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "{{ shop.money_format }}";
  
  // Use Shopify's money formatting
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, moneyFormat);
  }
  
  // Fallback if Shopify.formatMoney is not available
  return (cents/100).toLocaleString(Shopify.locale || 'en-US', {
    style: 'currency',
    currency: Shopify.currency ? Shopify.currency.active : 'USD'
  });
}